import { addToDate, dateDiff, now } from "@/common/utils/date";
import { useCurrentTramite } from "./useCurrentTramite";

export const useVencimientoPresentacion = () => {

  const tramite = useCurrentTramite();

  if (!tramite) return '-';

  const { vencimientoPresentacion } = getVencimientoPresentacion(tramite);
  return vencimientoPresentacion;
}

export const getVencimientoPresentacion = (tramite) => {
  const num_entrada = tramite?.num_entrada;
  const fec_entrada = tramite?.fecentrada;

  const diasEscritura = tramite.fecescritura
    ? dateDiff(addToDate(tramite.fecescritura, 46, 'days'), now(), 'days')
    : 0;

  const vencimientoPresentacion = tramite.fecescritura
    ? `${diasEscritura > 0 ? `${diasEscritura} días` : 'Vencido'} `
    : '-';

  return {
    vencimientoPresentacion: num_entrada && fec_entrada ? `✓ (${num_entrada ?? 'S/N'})` : vencimientoPresentacion,
    diasEscritura
  }
}